module.exports = __webpack_public_path__ + "images/a7f469236d5b54f761498cf38ecd0a9df4849f15dbb62782b3cc0e5eedf8c75a.svg";